<template>
    <div v-if="items.length" class="psl">
        <div class="psl__title"><v-icon x-small color="#b45309">mdi-alert-outline</v-icon> {{ items.length === 1 ? "Já existe um cadastro parecido" : "Já existem cadastros parecidos" }}. Confira antes de criar outro:</div>
        <div v-for="item in items" :key="item.id" class="psl__item">
            <span>{{ item.name }}<span v-if="item.scope" class="ui-muted"> · {{ item.scope }}</span><span v-if="!item.active" class="ui-muted"> · inativo</span></span>
            <button v-if="kind === 'judge' || openable" type="button" class="psl__link" @click="$emit('open', item)">abrir</button>
        </div>
    </div>
</template>

<script>
// Aviso de nomes parecidos nos dialogos de juiz e vara.
export default {
    name: "ProspectSimilarList",

    props: {
        items: { type: Array, default: () => [] },
        kind: { type: String, default: "judge" }, // judge | court
        openable: { type: Boolean, default: false },
    },
};
</script>

<style lang="scss" scoped>
@import "../../../assets/scss/ui/tokens";

.psl {
    margin-top: 8px;
    padding: 8px 12px;
    border: 1px solid #fde68a;
    border-radius: $ui-radius-sm;
    background: #fffbeb;
    font-size: 13px;
}

.psl__title {
    margin-bottom: 4px;
    color: #92400e;
}

.psl__item {
    display: flex;
    justify-content: space-between;
    gap: 8px;
    padding: 2px 0;
}

.psl__link {
    color: $ui-accent;
    font-weight: 600;
}
</style>
